/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, {
  useEffect,
  useRef,
  useState,
} from "react";
import Bridal from "./Bridal";
import { NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet-async";

const Home = () => {

  const phoneNumber = "6394941232";

  const statsRef = useRef(null);


  const [happyClients, setHappyClients] =
    useState(0);

  const [yearsExperience, setYearsExperience] =
    useState(0);



useEffect(() => {

  const observer = new IntersectionObserver(
    ([entry]) => {

      if (entry.isIntersecting) {

        setHappyClients(0);
        setYearsExperience(0);

        const clientsInterval = setInterval(() => {

          setHappyClients((prev) => {

            if (prev >= 3000) {
              clearInterval(clientsInterval);
              return 3000;
            }

            return prev + 20;

          });

        }, 20);

        const experienceInterval = setInterval(() => {

          setYearsExperience((prev) => {

            if (prev >= 7) {
              clearInterval(experienceInterval);
              return 7;
            }

            return prev + 1;

          });

        }, 300);

        return () => {
          clearInterval(clientsInterval);
          clearInterval(experienceInterval);
        };

      }

    },
    {
      threshold:0.4,
    }
  );

  if (statsRef.current) {
    observer.observe(statsRef.current);
  }

  return () => {

    if (statsRef.current) {
      observer.unobserve(statsRef.current);
    }

  };

}, []);

  const handleHeroBooking = () => {

    const message =
      "Hello, I want to book a beauty service.";

    const url =
      `https://wa.me/91${phoneNumber}?text=${encodeURIComponent(
        message
      )}`;

    window.open(url, "_blank");

  };


  const signatureServices = [
    {
      title: "Bridal Makeup",
      text: "Luxury bridal makeup designed around your features, outfit, jewellery and wedding style.",
    },
    {
      title: "HD & Party Makeup",
      text: "Camera-ready makeup for engagements, receptions, parties, photoshoots and special occasions.",
    },
    {
      title: "Professional Hairstyling",
      text: "Bridal and occasion hairstyles designed to complement your makeup and outfit.",
    },
    {
      title: "Bridal Styling",
      text: "Complete bridal preparation including makeup, hairstyling and styling assistance.",
    },
    {
      title: "Skincare & Beauty",
      text: "Professional beauty and skincare services to help you look and feel your best.",
    },
    {
      title: "Designer Lehenga Rental",
      text: "Explore our selection of designer outfits for weddings and special occasions.",
    },
  ];

  const reasonsToChooseUs = [
    "Premium beauty experience",
    "Professional makeup and hairstyling",
    "Personalized bridal looks",
    "Real bridal transformations",
    "Modern and traditional makeup styles",
    "Convenient location in Jhusi, Prayagraj",
  ];

  return (
    <>
     <Helmet>

        <title>
          ARSON'S BEAUTY ZONE | Premium Bridal Makeup & Beauty Salon in Jhusi, Prayagraj
        </title>

      <meta
        name="description"
        content="ARSON'S BEAUTY ZONE is a premium ladies beauty salon and bridal makeup studio in Jhusi, Prayagraj, offering bridal makeup, HD makeup, party makeup, hairstyling, bridal styling, skincare and designer lehenga rental."
      />

    </Helmet>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&family=Manrope:wght@300;400;500;600;700&display=swap');

          :root{
            --primary:#ffffff;
            --secondary:#bdbdbd;
            --dark:#050505;
            --light:#0d0d0d;
            --card:#141414;
            --border:#242424;
            --text:#d2d2d2;
          }

          *{
            margin:0;
            padding:0;
            box-sizing:border-box;
          }

          body{
            font-family:'Manrope',sans-serif;

            background:
            radial-gradient(
              circle at top right,
              rgba(255,255,255,0.04),
              transparent 30%
            ),
            #0d0d0d;

            overflow-x:hidden;
          }

          .luxury-heading{
            font-family:'Cormorant Garamond',serif;
          }

          .section-tag{
            color:var(--primary);
            letter-spacing:4px;
            font-size:13px;
            font-weight:700;
          }

          .premium-btn{
            position:relative;
            overflow:hidden;
            transition:all .45s ease;
          }

          .premium-btn:hover{
            transform:translateY(-5px);
            box-shadow:0 20px 40px rgba(0,0,0,0.15);
            filter:brightness(1.05);
          }

          .premium-btn::before{
            content:'';
            position:absolute;
            top:0;
            left:-120%;
            width:100%;
            height:100%;
            background:rgba(255,255,255,0.25);
            transform:skewX(-20deg);
            transition:.8s;
          }

          .premium-btn:hover::before{
            left:120%;
          }

          .service-card{
            background:var(--card);
            border:1px solid var(--border);
            border-radius:30px;
            overflow:hidden;
            transition:all .55s ease;
            box-shadow:0 15px 45px rgba(0,0,0,0.25);
            color:white;
            height:100%;
          }

          .service-card:hover{
            transform:translateY(-12px);
            box-shadow:0 25px 60px rgba(255,255,255,0.06);
          }

          .service-card img{
            transition:all .8s ease;
          }

          .service-card:hover img{
            transform:scale(1.08);
          }

          .gallery-img{
            transition:all .7s ease;
            border-radius:24px;
          }

          .gallery-img:hover{
            transform:scale(1.04);
            box-shadow:0 25px 50px rgba(255,255,255,0.08);
          }

          .fade-up{
            animation:fadeUp 1.2s ease forwards;
          }

          @keyframes fadeUp{

            from{
              opacity:0;
              transform:translateY(60px);
            }

            to{
              opacity:1;
              transform:translateY(0);
            }

          }

          @keyframes luxuryZoom{

            0%{
              transform:scale(1);
            }

            50%{
              transform:scale(1.03);
            }

            100%{
              transform:scale(1);
            }

          }

        @media(max-width:768px){

  .hero-heading{
    font-size:56px !important;
  }
    .premium-btn{
    margin-bottom: 0px !important
    }

  .section-heading{
    font-size:42px !important;
  }

  .hero-image{
    height:365px !important;
    max-width:100% !important;
    border-radius:22px !important;
  }

}
        `}
      </style>

      {/* HERO SECTION */}

      <section
        style={{
          minHeight:"100vh",
          paddingTop:"140px",
          background:
            "linear-gradient(to right,#050505,#111111,#050505)",
          display:"flex",
          alignItems:"center",
          position:"relative",
          overflow:"hidden",
        }}
      >

        {/* GLOW */}

        <div
          style={{
            position:"absolute",
            width:"450px",
            height:"550px",
            background:"#ffffff",
            filter:"blur(180px)",
            borderRadius:"50%",
            top:"-120px",
            right:"-120px",
            opacity:0.07,
          }}
        />

        <div className="container position-relative">

          <div className="row align-items-center">

            {/* TEXT */}

          <div className="col-lg-6 order-2 order-lg-1 text-white fade-up">

              <p className="section-tag">
                ARSON'S BEAUTY ZONE
              </p>

              <h1
                className="luxury-heading hero-heading"
                style={{
                  fontSize:"clamp(65px,8vw,120px)",
                  lineHeight:"0.95",
                  fontWeight:"700",
                }}
              >
                Premium Bridal Makeup &amp; Beauty Salon in Jhusi, Prayagraj
              </h1>

              <p
                style={{
                  maxWidth:"600px",
                  marginTop:"30px",
                  fontSize:"18px",
                  lineHeight:"2",
                  color:"#cfcfcf",
                }}
              >
                Welcome to ARSON’S BEAUTY ZONE, a premium ladies beauty salon
                and bridal makeup studio in Jhusi, Prayagraj. We specialize in
                bridal makeup, HD makeup, party makeup, professional
                hairstyling, bridal styling, skincare and complete beauty
                services for weddings, engagements, receptions and special
                occasions.
              </p>

              <p
                style={{
                  marginTop:"35px",
                  color:"#9d9d9d",
                  letterSpacing:"3px",
                  fontSize:"13px",
                }}
              >
                BRIDAL • HD MAKEUP • HAIRSTYLING • SKINCARE • LEHENGA RENTAL
              </p>

              <div className="d-flex gap-3 flex-wrap mt-5">

                <button
                  onClick={handleHeroBooking}
                  className="premium-btn"
                  style={{
                    background:"#ffffff",
                    color:"#000",
                    border:"1px solid rgba(255,255,255,0.08)",
                    boxShadow:"0 10px 40px rgba(255,255,255,0.08)",
                    padding:"18px 42px",
                    borderRadius:"60px",
                    fontWeight:"700",
                    marginBottom:"20px"
                  }}
                >
                  Book Appointment
                </button>

             <NavLink
                  to={"/services"}
                  onClick={() => {
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  }}

             >
                <button
                  className="premium-btn"
                  style={{
                    background:"transparent",
                    color:"white",
                    border:
                      "1px solid rgba(255,255,255,0.25)",
                    padding:"18px 42px",
                    borderRadius:"60px",
                    marginBottom:"20px"
                  }}
                >
                  Explore Services
                </button>
              </NavLink>
              </div>

            </div>

            {/* IMAGE */}

           <div className="col-lg-6 order-1 order-lg-2 text-center mb-5 mb-lg-0">

              <img
                src="https://i.pinimg.com/736x/cb/f9/81/cbf9815d9998f64516690f8fca6304e6.jpg"
                alt="Luxury bridal makeup at Arson's Beauty Zone Prayagraj"
                className="hero-image"
                style={{
                  width:"100%",
                  maxWidth:"580px",
                  height:"790px",
                  objectFit:"cover",
                  borderRadius:"30px",
                  animation:
                    "luxuryZoom 8s ease-in-out infinite",
                  filter:
                    "drop-shadow(0 35px 60px rgba(255,255,255,0.10))",
                }}
              />

            </div>

          </div>

        </div>

      </section>

   
      {/* ABOUT */}

      <section
        style={{
          padding:"120px 0",
          background:"#101010",
        }}
      >

        <div className="container">

          <div className="row align-items-center">

            <div className="col-lg-6 mb-5">

              <img
                src="https://i.pinimg.com/736x/57/4e/b5/574eb58b99bb66d458a1c9d2ef76447f.jpg"
                alt="Beauty salon services and bridal makeup in Prayagraj"
                style={{
                  width:"100%",
                  height:"700px",
                  objectFit:"cover",
                  borderRadius:"30px",
                }}
              />

            </div>

            <div className="col-lg-6 text-white ps-lg-5">

              <p className="section-tag">
                ABOUT US
              </p>

              <h2
                className="luxury-heading"
                style={{
                  fontSize:"70px",
                  lineHeight:"1",
                  marginBottom:"30px",
                }}
              >
                Beauty that feels elegant and completely you
              </h2>

              <p
                style={{
                  color:"#bdbdbd",
                  lineHeight:"2",
                  fontSize:"18px",
                }}
              >
                Our goal is simple — to create a look that feels beautiful,
                elegant and completely you. From modern glam looks to
                traditional bridal transformations, every detail is crafted
                with creativity, perfection and premium care.
              </p>

              <div className="d-flex gap-5 mt-5">

                <div>

                  <h3 className="text-white luxury-heading">
                    3000+
                  </h3>

                  <p style={{color:"#bdbdbd"}}>
                    Happy Clients
                  </p>

                </div>

                <div>

                  <h3 className="text-white luxury-heading">
                    7+
                  </h3>

                  <p style={{color:"#bdbdbd"}}>
                    Years Experience
                  </p>

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>

      {/* SIGNATURE SERVICES */}
      <section
        id="signature-services"
        style={{ padding: "120px 0", background: "#080808" }}
      >
        <div className="container">
          <div className="text-center mb-5">
            <p className="section-tag">OUR SIGNATURE SERVICES</p>
            <h2
              className="luxury-heading text-white section-heading"
              style={{ fontSize: "70px", marginBottom: "20px" }}
            >
              Complete beauty for every occasion
            </h2>
            <p
              style={{
                maxWidth: "760px",
                margin: "0 auto",
                color: "#bdbdbd",
                fontSize: "17px",
                lineHeight: "1.9",
              }}
            >
              Premium makeup, styling and beauty services for weddings,
              engagements, receptions and your most special moments.
            </p>
          </div>

          <div className="row g-4">
            {signatureServices.map((service, index) => (
              <div className="col-md-6 col-lg-4" key={service.title}>
                <article className="service-card p-4 p-lg-5">
                  <span
                    style={{
                      display: "block",
                      marginBottom: "25px",
                      color: "#8f8f8f",
                      fontSize: "12px",
                      letterSpacing: "3px",
                    }}
                  >
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <h3
                    className="luxury-heading"
                    style={{ fontSize: "38px", marginBottom: "20px" }}
                  >
                    {service.title}
                  </h3>
                  <p
                    style={{
                      margin: 0,
                      color: "#bdbdbd",
                      fontSize: "16px",
                      lineHeight: "1.8",
                    }}
                  >
                    {service.text}
                  </p>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Bridal />

      {/* WHY CHOOSE US */}
      <section style={{ padding: "120px 0", background: "#0b0b0b" }}>
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-5">
              <p className="section-tag">WHY CHOOSE US</p>
              <h2
                className="luxury-heading text-white section-heading"
                style={{ fontSize: "70px", lineHeight: 1 }}
              >
                Your look, thoughtfully created
              </h2>
            </div>

            <div className="col-lg-7">
              <div className="row g-3">
                {reasonsToChooseUs.map((reason) => (
                  <div className="col-md-6" key={reason}>
                    <div
                      style={{
                        height: "100%",
                        padding: "24px",
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                        border: "1px solid #242424",
                        borderRadius: "18px",
                        background: "#141414",
                        color: "#e8e8e8",
                      }}
                    >
                      <span style={{ color: "#ffffff", fontSize: "20px" }}>
                        ✓
                      </span>
                      <span>{reason}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* STATS */}

      <section
        ref={statsRef}
        style={{
          padding:"100px 0",
          background:"#111111",
        }}
      >

        <div className="container">

          <div className="row text-center">

            <div className="col-lg-6 mb-4">

              <h2
                className="luxury-heading text-white"
                style={{
                  fontSize:"90px",
                  fontWeight:"700",
                }}
              >
                {happyClients}+
              </h2>

              <p
                style={{
                  color:"#bdbdbd",
                  letterSpacing:"3px",
                }}
              >
                HAPPY CLIENTS
              </p>

            </div>

            <div className="col-lg-6 mb-4">

              <h2
                className="luxury-heading text-white"
                style={{
                  fontSize:"90px",
                  fontWeight:"700",
                }}
              >
                {yearsExperience}+
              </h2>

              <p
                style={{
                  color:"#bdbdbd",
                  letterSpacing:"3px",
                }}
              >
                YEARS EXPERIENCE
              </p>

            </div>

          </div>

        </div>

      </section>

      {/* VISIT OUR STUDIO */}
      <section style={{ padding: "120px 0", background: "#050505" }}>
        <div className="container">
          <div
            className="row g-0 overflow-hidden"
            style={{ border: "1px solid #242424", borderRadius: "30px" }}
          >
            <div
              className="col-lg-7 p-4 p-md-5"
              style={{ background: "#141414" }}
            >
              <p className="section-tag">VISIT OUR STUDIO</p>
              <h2
                className="luxury-heading text-white section-heading"
                style={{ fontSize: "65px", lineHeight: 1, marginBottom: "30px" }}
              >
                ARSON’S BEAUTY ZONE
              </h2>
              <address
                style={{
                  marginBottom: "28px",
                  color: "#c8c8c8",
                  fontSize: "18px",
                  fontStyle: "normal",
                  lineHeight: "1.9",
                }}
              >
                1/220 MIG AVAS VIKAS COLONY JHUSI PRAYAGRAJ
                <br />
                Uttar Pradesh – 211019
              </address>

              <div className="d-flex flex-column gap-3">
                <p style={{ margin: 0, color: "#bdbdbd" }}>
                  <strong className="text-white">Call: </strong>
                  <a
                    href="tel:+916394941232"
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    +91 6394941232
                  </a>
                  {" / "}
                  <a
                    href="tel:+917800400041"
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    +91 7800400041
                  </a>
                </p>
                <p style={{ margin: 0, color: "#bdbdbd" }}>
                  <strong className="text-white">Opening Hours: </strong>
                  Monday–Sunday, 11:00 AM–8:00 PM
                </p>
              </div>
            </div>

            <div
              className="col-lg-5 d-flex align-items-center justify-content-center p-4 p-md-5 text-center"
              style={{ background: "#ffffff", color: "#050505" }}
            >
              <div>
                <p
                  style={{
                    marginBottom: "18px",
                    fontSize: "12px",
                    fontWeight: 700,
                    letterSpacing: "3px",
                  }}
                >
                  BOOK YOUR BRIDAL APPOINTMENT
                </p>
                <h3
                  className="luxury-heading"
                  style={{ fontSize: "46px", lineHeight: 1.05 }}
                >
                  Planning your wedding or special occasion?
                </h3>
                <p style={{ margin: "24px 0 30px", lineHeight: 1.8 }}>
                  Contact ARSON’S BEAUTY ZONE today and schedule your
                  consultation.
                </p>
                <button
                  type="button"
                  className="premium-btn"
                  onClick={handleHeroBooking}
                  style={{
                    padding: "17px 34px",
                    border: 0,
                    borderRadius: "60px",
                    background: "#050505",
                    color: "#ffffff",
                    fontWeight: 700,
                  }}
                >
                  Book on WhatsApp
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );

};

export default Home;